import {
  TModelValueType,
} from './input-qmulus-dashboard-widget-threshold-value.ts';

const modelValueType: Record<TModelValueType, string> = {
  value: 'Statický',
  factoredLimit: 'Dynamický',
  limitMin: 'Minimum osi',
  limitMax: 'Maximum osi',
  infinity: '+∞',
};

export default {
  modelValueType,
};
